import {
  WalletHistoryItemWrapper,
  WalletHistoryItemMainWrapper,
  WalletHistoryItemBase,
  WalletHistoryItemPub,
} from "./style";
import { WalletSkeletonWhiteBox } from "../../../../style/skeleton";

const WalletHistorySkeletonItem = () => {
  return (
    <WalletHistoryItemWrapper isSelected={false}>
      <WalletHistoryItemMainWrapper>
        <WalletHistoryItemBase>
          <WalletSkeletonWhiteBox width="55px" height="13px" />
          <WalletHistoryItemPub>
            <WalletSkeletonWhiteBox width="70px" height="18px" />
            <WalletSkeletonWhiteBox width="150px" height="13px" />
          </WalletHistoryItemPub>
        </WalletHistoryItemBase>
        <WalletSkeletonWhiteBox width="50px" height="18px" />
      </WalletHistoryItemMainWrapper>
    </WalletHistoryItemWrapper>
  );
};

export default WalletHistorySkeletonItem;
